import { IconProps } from '@/types/icon';

export function IconePessoa({ size, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="pessoa"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M10.0002 4.91665C10.9668 4.91665 11.7502 5.69998 11.7502 6.66665C11.7502 7.63331 10.9668 8.41665 10.0002 8.41665C9.0335 8.41665 8.25016 7.63331 8.25016 6.66665C8.25016 5.69998 9.0335 4.91665 10.0002 4.91665ZM10.0002 12.4166C12.4752 12.4166 15.0835 13.6333 15.0835 14.1666V15.0833H4.91683V14.1666C4.91683 13.6333 7.52516 12.4166 10.0002 12.4166ZM10.0002 3.33331C8.1585 3.33331 6.66683 4.82498 6.66683 6.66665C6.66683 8.50831 8.1585 9.99998 10.0002 9.99998C11.8418 9.99998 13.3335 8.50831 13.3335 6.66665C13.3335 4.82498 11.8418 3.33331 10.0002 3.33331ZM10.0002 10.8333C7.77516 10.8333 3.3335 11.95 3.3335 14.1666V16.6666H16.6668V14.1666C16.6668 11.95 12.2252 10.8333 10.0002 10.8333Z"
        fill="currentColor"
      />
    </svg>
  );
}
